import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Switch } from 'antd';
import Field from '../../atoms/Field';
import { fieldsShape } from '../../organisms/SimuladorRe/initialState';
import Description from '../../../../atoms/Description';
import { moneyFormat } from '../../../../../services/util';

function CamposSimulador({
  fields,
  onChangeFieldValue,
  onBlurField,
  isAdministrativo,
  toggleAdministrativo,
  remuneracaoTotal,
}) {
  return (
    <>
      <Row type="flex" gutter={[16, 32]} style={{ marginBottom: '32px' }}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <span>Administrativo</span>
          <br />
          <Switch
            data-testid="switchAdministrativo"
            checked={isAdministrativo}
            onChange={toggleAdministrativo}
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Description label="Remuneração Total:">
            <span data-testid="remuneracaoTotal">
              {moneyFormat(remuneracaoTotal)}
            </span>
          </Description>
        </Col>
      </Row>
      <Row type="flex" gutter={[16, 16]}>
        {Object.entries(fields).map(
          ([id, { label, valueType, isVisible, value, isEnabled }]) =>
            isVisible && (
              <Col xs={12} sm={8} md={8} lg={6} xl={4} key={id}>
                <Field
                  id={id}
                  label={label}
                  value={value}
                  valueType={valueType}
                  onChangeFieldValue={onChangeFieldValue}
                  onBlurField={onBlurField}
                  isEnabled={isEnabled}
                />
              </Col>
            )
        )}
      </Row>
    </>
  );
}

CamposSimulador.propTypes = {
  fields: fieldsShape.isRequired,
  onChangeFieldValue: PropTypes.func.isRequired,
  onBlurField: PropTypes.func.isRequired,
  isAdministrativo: PropTypes.bool.isRequired,
  remuneracaoTotal: PropTypes.number.isRequired,
  toggleAdministrativo: PropTypes.func.isRequired,
};

export default CamposSimulador;
